import React from 'react';
import ShipCollection from "../share/ship-collection.js";
import FleetFormulas from "../share/formulas/fleet-formulas.js";
import * as util from "../other/util.js";

export default class ShipStatistics extends React.Component {
    render() {
        let ship_design = this.props.shipDesign;
        const pseudo_fleet = new ShipCollection();
        pseudo_fleet.addShips(ship_design, 1);

        const launch_time = FleetFormulas.getTimeForLaunch(pseudo_fleet);
        const planet_hop_time = FleetFormulas.getTimeForMove(pseudo_fleet, { x: 0, y: 0, z: 0 }, { x: 0, y: 0, z: 1 });
        const system_hop_time = FleetFormulas.getTimeForMove(pseudo_fleet, { x: 0, y: 0, z: 0 }, { x: 0, y: 1, z: 0 });

        const launch_fuel = FleetFormulas.getFuelForLaunch(pseudo_fleet);
        const planet_hop_fuel = FleetFormulas.getFuelForMove(pseudo_fleet, { x: 0, y: 0, z: 0 }, { x: 0, y: 0, z: 1 });
        const system_hop_fuel = FleetFormulas.getFuelForMove(pseudo_fleet, { x: 0, y: 0, z: 0 }, { x: 0, y: 1, z: 0 });

        return (
            <div>
                <h4>Ship Statistics</h4>
                <table className="generic-list">
                    <tbody>
                        <tr>
                            <td style={{ width: "180px" }}>Attack</td>
                            <td>{ship_design.stats.attack}</td>
                        </tr>
                        <tr>
                            <td>Hull Points</td>
                            <td>{ship_design.stats.structure}</td>
                        </tr>
                        <tr>
                            <td>Repair Rate</td>
                            <td>{ship_design.stats.repair} hph</td>
                        </tr>
                        <tr>
                            <td>Armor</td>
                            <td>{ship_design.stats.armor}</td>
                        </tr>
                        <tr>
                            <td>Shield</td>
                            <td>{ship_design.stats.shield}</td>
                        </tr>
                        <tr>
                            <td>Acceleration</td>
                            <td>{pseudo_fleet.stats.acceleration}</td>
                        </tr>
                        <tr>
                            <td>Cargo</td>
                            <td>{ship_design.stats.cargo}</td>
                        </tr>
                        <tr>
                            <td>Thread</td>
                            <td>{ship_design.stats.thread}</td>
                        </tr>
                        <tr>
                            <td>Launch Time</td>
                            <td>
                                {pseudo_fleet.stats.acceleration === 0 ? "Unknown" : <span><util.NiceInlineTimeSpan timeSpan={launch_time} /> (<util.ShortNumber number={launch_fuel} /> fuel)</span>}
                            </td>
                        </tr>
                        <tr>
                            <td>Planet Hop</td>
                            <td>
                                {pseudo_fleet.stats.acceleration === 0 ? "Unknown" : <span><util.NiceInlineTimeSpan timeSpan={planet_hop_time} /> (<util.ShortNumber number={planet_hop_fuel} /> fuel)</span>}
                            </td>
                        </tr>
                        <tr>
                            <td>System Hop</td>
                            <td>
                                {pseudo_fleet.stats.acceleration === 0 ? "Unknown" : <span><util.NiceInlineTimeSpan timeSpan={system_hop_time} /> (<util.ShortNumber number={system_hop_fuel} /> fuel)</span>}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}